import { users } from "@api/courses/reviewStats/users/path";

export const reviewStats = {
  users,
};
